import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class StatusController implements angular.IComponentController {
    displayMessage: string;
    isLoading: boolean;
    loadingMessage: string;
    message: string;
    status: number;
    statusTitle: string;

    static $inject = ['$translate'];
    constructor(private _$translate: angular.translate.ITranslateService) {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['statusTitle']) {
            const statusTitle = changesObj['statusTitle'].currentValue;
            this.displayMessage = this.getMessage(this.status, this.message, statusTitle);
        }
        if (changesObj['message']) {
            const message = changesObj['message'].currentValue;
            this.displayMessage = this.getMessage(this.status, message, this.statusTitle);
        }
    }

    private getMessage(status: number, message: string, statusTitle: string): string {
        let displayMessage = '';
        if (!message) {
            switch (status) {
                case 0:
                    message = 'OK';
                    break;
                case 1:
                    message = 'Warning';
                    break;
                case 2:
                    message = 'Error';
                    break;
            }
        }
        if (message && status >= 0) {
            displayMessage = this._$translate.instant(message);
            if (statusTitle) {
                displayMessage = displayMessage + '\n' + this._$translate.instant(statusTitle);
            }
        }
        return displayMessage;
    }
}

export const wtStatus: ComponentDefinition = {
    componentId: 'wtStatus',
    controller: StatusController,
    template: require('./status.component.html'),
    controllerAs: 'vm',
    bindings: {
        status: '<',
        message: '<?',
        statusTitle: '<?'
    }
};
